// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { MessageParticipantNameResponse } from './message-participant-name-response';

/** See com.rev360.pms.api.controller.messaging.MessageParticipantResponse */
/* istanbul ignore next */
@GandalfModel
export class MessageParticipantResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	attachmentCount!: number | null;

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: Number })
	messageId!: number;

	@GandalfProperty({ designType: Number })
	messageParticipantId!: number;

	@GandalfProperty({ designType: MessageParticipantNameResponse })
	messageSender!: MessageParticipantNameResponse;

	@GandalfConstantDecorator(constants.MessagePriority)
	@GandalfProperty({ designType: constants.MessagePriority })
	priority!: constants.MessagePriority | null;

	@GandalfProperty({ designType: Boolean })
	starred!: boolean;

	@GandalfConstantDecorator(constants.MessageParticipantStatus)
	@GandalfProperty({ designType: constants.MessageParticipantStatus })
	statusCode!: constants.MessageParticipantStatus;

	@GandalfProperty({ designType: String })
	subject!: string | null;

}
